"use client";
import { useLocale } from "next-intl";
import Image from "next/image";
import Link from "next/link";
export const Logo = ({ width, height, nameSite }) => {
  const locale = useLocale();
  return (
    <Link href={`/`} className="-m-1.5 p-1.5 min-w-[70px]" locale={locale}>
      <span className="sr-only">Your Company</span>
      <Image
        priority
        quality={65}
        className={["sayt.az", ""].includes(nameSite) ? "hidden" : ""}
        src={`/icons/websiteca.svg`}
        width={width || (nameSite != "websiteca.com" ? 114 : 170)}
        height={height || 32}
        alt="logo"
      />
      <Image
        priority
        quality={65}
        className={["websiteca.com", ""].includes(nameSite) ? "hidden" : ""}
        src={`/icons/saytaz.svg`}
        width={width || (nameSite != "websiteca.com" ? 114 : 170)}
        height={height || 32}
        alt="logo"
      />
    </Link>
  );
}
